<template>
<div>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-title>Transmitir Guia a Tramaco</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-combobox
              v-model="localidad"
              :items="lstLocalidad"
              label="Localidad"
              item-value="id"
              item-text="nombre"
              return-object
              clearable
              :rules="[reglas.requeridoCbx]"
          ></v-combobox>
        </v-row>
        <!--v-row dense>
          <v-combobox
              v-model="centroCosto"
              :items="lstCentroDeCosto"
              label="Centro de Costo"
              item-value="id"
              item-text="nombre"
              return-object
              clearable
              :rules="[reglas.requeridoCbx]"
          ></v-combobox>
        </v-row-->
        <v-row dense>
          <v-combobox
              v-model="contrato"
              :items="lstContrato"
              label="Contrato"
              item-value="id"
              item-text="numero"
              return-object
              clearable
              :rules="[reglas.requeridoCbx]"
          ></v-combobox>
        </v-row>
        <v-row dense v-if="contrato != null">
          <v-combobox
              v-model="producto"
              :items="productos"
              label="Producto"
              item-value="id"
              item-text="nombre"
              return-object
              clearable
              :rules="[reglas.requeridoCbx]"
          ></v-combobox>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary" @click="enviar()"> Enviar a Tramaco </v-btn>
      </v-card-actions>
    </v-form>
    </v-card>
    <v-dialog  :scrollable="true" v-model="dlgMensaje" width="900" transition="dialog-bottom-transition" persistent :fullscreen="false">
      <v-card>
        <v-toolbar dark dense color="#96298A" max-height="35" height="35">
            <v-toolbar-title>Resultados</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-divider vertical />
            <v-btn icon dark @click="closeMensajes()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-0">
            <v-simple-table>
              <thead>
                <tr>
                  <th>Guía</th>
                  <th>Resultado</th>
                  <th>Guía Operador</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(msg,index) in mensajes" :key="index">
                  <td>{{ msg.guia }}</td>
                  <td>{{ msg.mensaje }}</td>
                  <td>{{ msg.guia_operador }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import apicon from '../plugins/apicon';
export default {
  props:{
    id: {
      type: Number,
      default: 0,
    },
    guias : {
      type : Array
    },
    mode:{
      type: String,
      default: 'CL'
    }
  },
  watch:{
    contrato: function(item){
      if(item){
        this.producto = null;
        this.productos = item.lstProducto;
      }
    }
  },
  data(){
    return{
      urlContrato: "https://wsqa.tramaco.com.ec/dmz-tramaco-comercial-ws/webresources/consultaTk/consultarLocalidadContrato",
      config : {
        headers: {
          Authorization: "eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJ0bWMtY2xpZW50ZS13cyIsImV4cCI6MTY5MTUxNDEzNywiaWF0IjoxNjgzNTY1MzM3LCJuYW1lIjoiMTc5MjY2MjU0MDAwMSJ9.0J6Bm8_6ATDLK1TmwT1bIPcCEPw8qj6yi-Haod4JuxUCkZK_oJSX9QKoLn9j428j-s2Og_fQfCuLKDXFK6ZNBQ"
        }
      },
      //lstCentroDeCosto: [],
      lstContrato: [],
      lstLocalidad: [],
      localidad: null,
      centroCosto: null,
      contrato: null,
      productos: [],
      producto: null,
      valid: true,
      mensajes: [],
      dlgMensaje : false
    }
  },
  methods:{
    getContratoData: function(){
     apicon.getDataApi(apicon.getApiBaseUrl() + 'contratotramaco').then((result) => {
        //this.lstCentroDeCosto = result.data.lstCentroDeCosto;
        this.lstContrato = result.data.lstContrato;
        this.lstLocalidad = result.data.lstLocalidad;
      });
    },
    enviar: function(){
      let url = 'enviartramaco'
      if (this.$refs.form.validate()) {
        apicon.saveDataApi(apicon.getApiBaseUrl() + url,{
          guias : this.guias,
          datosTramaco: {
            localidad : this.localidad,
            centroCosto : this.centroCosto,
            contrato : this.contrato,
            producto: this.producto
          },
          mode : this.mode
        }).then((result) => {
          result.message.forEach(el => {
            this.mensajes.push({
              guia : el.guia,
              mensaje : el.resp.cuerpoRespuesta.codigo == 1 ? el.resp.cuerpoRespuesta.mensaje : el.resp.cuerpoRespuesta.excepcion,
              guia_operador : el.resp.cuerpoRespuesta.codigo == 1 ? el.resp.salidaGenerarGuiaWs.lstGuias[0].guia : null,
            })
          });
          this.dlgMensaje = true
        })
      }
    },
    closeMensajes: function(){
      this.dlgMensaje = false;
      this.mensajes = [];
    }
  },
  mounted: function(){
    this.getContratoData();
  }
}
</script>

<style>

</style>
